// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.valve-selection-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.valve-selection-modal .modal-header {
  border: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 16px 24px;
  overflow: visible;
}
.valve-selection-modal .modal-header h2 {
  grid-column: 2;
  margin: 0;
  font-size: 2rem;
  font-weight: 500;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
}
.valve-selection-modal .modal-header button {
  grid-column: 3;
  justify-self: end;
}
.valve-selection-modal .modal-content {
  padding: 0 24px;
  min-height: 0;
  overflow: hidden;
  border: 0;
  flex: 1;
}
.valve-selection-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  margin-top: auto;
}
.valve-selection-modal .modal-actions button {
  min-width: 120px;
}

.selection-pill {
  display: inline-flex;
  align-items: center;
  position: relative;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background-color: #0066b2;
  color: black;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  border: 1px solid #c7d2fe;
  white-space: nowrap;
}

.tooltip-text {
  visibility: hidden; /* Initially hidden */
  background-color: #555; /* Tooltip background color */
  color: #fff; /* Tooltip text color */
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1000;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px; /* Limit tooltip width */
  /* Position the tooltip under the module title */
  top: 100%; /* Adjust this value to position it below the title */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0; /* Make it invisible */
  transition: opacity 0.3s; /* Smooth fade-in effect */
}

.selection-pill:hover .tooltip-text {
  visibility: visible; /* Show the tooltip on hover */
  opacity: 1; /* Make it fully visible */
}

::ng-deep .valve-selection-modal-dialog {
  width: 90vw;
  height: 90vh;
}
::ng-deep .valve-selection-modal-dialog .mdc-dialog__content {
  max-height: none;
}

:host ::ng-deep app-piping-admin-search {
  display: block;
}
:host ::ng-deep app-piping-admin-search .container-horizontal {
  display: flex;
  gap: 10px;
}
:host ::ng-deep app-piping-admin-search .filters-container {
  max-height: calc(90vh - 250px);
  overflow-y: auto;
}
:host ::ng-deep app-piping-admin-search .search-result-pane {
  display: flex;
  flex-direction: column;
}
:host ::ng-deep app-piping-admin-search .modal-table-container {
  max-height: calc(90vh - 320px);
  overflow-y: auto;
}
:host ::ng-deep app-piping-admin-search .items-per-page {
  margin-bottom: 0;
  padding-bottom: 0;
}

.cancel-btn {
  border: 1px solid #0066b2;
  color: #0066b2;
  background-color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.cancel-btn:hover {
  background-color: rgba(0, 102, 178, 0.04);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
